import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core'
import * as _ from 'lodash'
import { NGXLogger } from 'ngx-logger'
import { ApiService } from 'src/app/core/services/api.service'
import { PageService } from 'src/app/core/services/page.service'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

@Component({
    selector: 'app-header-search',
    templateUrl: './header-search.component.html',
    styleUrls: ['./header-search.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderSearchComponent implements OnInit {

  equipmentProviderInActive: boolean;
  constructor(
    public logger: NGXLogger,
    private api: ApiService,
    public page: PageService,
    public sharedDataService: SharedDataService
  ) {
    this.fetchVideos()
    this.fetchArticles()
    this.equipmentProviderInActive = this.sharedDataService.getPortalType()

  }

  @Input() searchBox = false
  @Input() dataSource: any = []
  @Input() fields = {}
  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>()

  dataFormatted: any = []
  dataKeys = []

  videos = []
  articles = []


  fetchVideos() {
    return this.api.getWhyUsPage().toPromise()
      .then((data) => {
        const videos = data.data.attributes.videos.videos
        this.videos = videos.map(x => ({
          Category: 'Videos',
          header: x.header,
          title: x.title,
          Text: `${x.header} ${x.title}`,
          URL: '/why-us#videosContainer'
        }))
      })
      .catch((err) => {
        this.logger.error(err)
      })
  }

  fetchArticles() {
    return this.api.getArticles().toPromise()
      .then((data) => {
        const articles = data.data[0].items
        this.articles = articles.map(x => ({
          Category: 'Articles',
          cat: x.category,
          Text: x.title,
          URL: '/article/' + x.title.toLowerCase().replace(/[\.\,\!\?]/g, '').replace(/\s/g, '-')
        }))
      })
      .catch((err) => {
        this.logger.error(err)
      })
  }

  ngOnInit() {
    this.logger.info(this.dataSource)
    this.logger.info(this.fields)
    // this.dataSource = this.dataSource[0]?.data?.map(t => t = t.attributes)
    this.dataFormatted = _.groupBy(this.dataSource, x => x.Category)
    this.dataKeys = Object.keys(this.dataFormatted)
    this.dataKeys = this.sortDataKeys(this.dataKeys)
    this.sortKeysValuesByOrder(this.dataFormatted)
    this.logger.info(this.dataFormatted)
    // this.dataFormatted = _.sortBy(this.dataFormatted, x => x.order)
  }

  sortKeysValuesByOrder(data) {
    for (const k of Object.keys(data)) {
      data[k] = _.sortBy(data[k], x => x.order)
    }
  }

  clickSearch(e) {
    const links = e.target.dataset.link.split('#')
    this.searchBox = !this.searchBox
    this.closeEvent.emit()
    this.page.goAndScroll(links[0], links[1])
  }

  cancelSearch() {
    this.searchBox = !this.searchBox
    this.closeEvent.emit()
  }

  defaultList() {
    this.dataFormatted = _.groupBy(this.dataSource, x => x.Category)
    this.dataKeys = Object.keys(this.dataFormatted)
    this.dataKeys = this.sortDataKeys(this.dataKeys)
    this.sortKeysValuesByOrder(this.dataFormatted)
  }

  filterList(text: string, isSearch: boolean = false) {
    if (!text) {
      return this.defaultList()
    }
    text = text.trim().toLowerCase()
    let filterSource = this.dataSource.filter(x => x.Category.toLowerCase().includes(text) || x.Text.toLowerCase().includes(text))


    const filterSourceArticles = this.articles.filter(x =>
       x.Category.toLowerCase().includes(text)
    || x.cat.toLowerCase().includes(text)
    || x.Text.toLowerCase().includes(text))

    const filterSourceVideos = this.videos.filter(x =>
       x.Category.toLowerCase().includes(text)
    || x.Text.toLowerCase().includes(text))


    filterSource = filterSource.concat(filterSourceArticles)
    filterSource = filterSource.concat(filterSourceVideos)

    this.logger.info(filterSource)
    if (filterSource.length === 0) {
      // this.dataFormatted = {'No entries found': [{Text: '', Category: 'Sorry', URL:'#'}]}
      this.dataFormatted = { 'No entries found': [] }
      this.dataKeys = Object.keys(this.dataFormatted)
      this.dataKeys = this.sortDataKeys(this.dataKeys, isSearch)
      this.sortKeysValuesByOrder(this.dataFormatted)
      return
    }
    this.dataFormatted = _.groupBy(filterSource, x => x.Category)
    this.dataKeys = Object.keys(this.dataFormatted)
    this.dataKeys = this.sortDataKeys(this.dataKeys, true)
    this.sortKeysValuesByOrder(this.dataFormatted)
  }

  sortDataKeys(dataKeys: any[], isSearch: boolean = false) {

    const sortOrderList = [
      'Home',
      'Why iCreditWorks',
      'Experience',
      'Policies',
      'Articles',
      'Videos'
    ]

    let newList = Array.from(dataKeys)
    const stash = []

    // first exclude stash
    for (let i = 0; i < dataKeys.length; i++) {
      const key = dataKeys[i]
      const idx = sortOrderList.indexOf(key)
      if (idx === -1) {
        newList[i] = null
        stash.push(key)
      }
    }
    if (isSearch) {
      return newList
    }
    // second sort with provided list
    newList = newList.filter(x => x !== null)
    const res = new Array(newList.length)
    for (const key of newList) {
      // console.log(key)
      const idx = sortOrderList.indexOf(key)
      if (idx !== -1) {
        res[idx] = key
      }
    }

    // concat
    res.push(...stash)
    return res.filter(key => key != null)
  }



  updateListOnChange(e) {
    this.dataFormatted = _.groupBy(this.dataSource, x => x.Category)
    this.filterList(e.target.value)
  }
}
